import React, { useEffect, useState, useRef } from "react";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
} from "reactstrap";
import { showLoading } from "react-global-loading";
import classnames from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import CheckLists from "./CheckLists";
import AreaList from "./AreaList";
import TopicList from "./TopicList";
import "../Standards/Standards.scss";
import FeatherIcon from "feather-icons-react";
import SimpleBar from "simplebar-react";
import MetisMenu from "metismenujs";
import { Toolbar } from "../../components/Common/LegacyGridAdapter";

//Import Icons

// //Import Scrollbar

const ChecklistIndex = () => {
  const navigate = useNavigate();
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");
  const [newChecklistRequest, setNewChecklistRequest] = useState(0);
  const [refreshRequest, setRefreshRequest] = useState(0);
  const [newAreaRequest, setNewAreaRequest] = useState(0);
  const [newTopicRequest, setNewTopicRequest] = useState(0);
  const ref = useRef();

  useEffect(() => {
    //var menu = new MetisMenu("#sub-menu");
  }, []);

  return (
    <React.Fragment>
      <div className="page-content standards-page piers-page">
        <Container fluid>
          <header className="standards-page__header piers-page-header">
            <div>
              <h1 className="piers-page-title">Checklists</h1>
              <p>
                Manage inspection checklists, areas, and topics used across
                review workflows.
              </p>
            </div>
            <div className="d-flex gap-2">
              {activeTab === 1 && (
                <button
                  type="button"
                  className="btn btn-outline-primary piers-refresh-button"
                  onClick={() => setRefreshRequest((request) => request + 1)}
                >
                  <i className="bx bx-refresh" aria-hidden="true" /> Refresh
                </button>
              )}
              {activeTab === 1 && (
                <button
                  type="button"
                  className="btn btn-outline-primary"
                  onClick={() => navigate("/system/checklist/import")}
                >
                  <i className="bx bx-import" /> Import Checklist
                </button>
              )}
              <button
                type="button"
                className="standards-page__create"
                onClick={() => {
                  if (activeTab === 1)
                    setNewChecklistRequest((request) => request + 1);
                  if (activeTab === 2)
                    setNewAreaRequest((request) => request + 1);
                  if (activeTab === 3)
                    setNewTopicRequest((request) => request + 1);
                }}
              >
                <i className="bx bx-plus" />{" "}
                {activeTab === 1
                  ? "New Checklist"
                  : activeTab === 2
                  ? "New Area"
                  : "New Topic"}
              </button>
            </div>
          </header>
          <CardBody className="standards-page__body">
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs className="standards-page__tabs">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>Checklist(s)</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      setactiveTab(2);
                    }}
                  >
                    <span>Checklist Area</span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      setactiveTab(3);
                    }}
                  >
                    <span>Checklist Topic</span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="twitter-bs-wizard-tab-content standards-page__tabs-content"
                style={{ paddingTop: "10px" }}
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <CheckLists
                    createRequest={newChecklistRequest}
                    refreshRequest={refreshRequest}
                  />
                </TabPane>
                <TabPane tabId={2}>
                  <AreaList createRequest={newAreaRequest} />
                </TabPane>
                <TabPane tabId={3}>
                  <TopicList createRequest={newTopicRequest} />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ChecklistIndex;
